export const isSSR = typeof window === 'undefined';
export const isLocal = process.env.REACT_APP_APP_ENV === 'local';
export const isProduction = process.env.REACT_APP_APP_ENV === 'production';

export const localStorageExists = typeof localStorage !== 'undefined';
